import { Field } from 'ngx-angular-query-builder';
import { FieldMetadataCollectionBuilder, FilterOperators, FieldMetadataCollection, FilterFieldProvider } from '@common/filter/filtering';
import { asDate, mapDate, ArrayToFilterListItemBuilder } from '@common/filter/services/array-to-filter-list-item-builder';
import { IRow, ITableColumn } from '@common/models/table';
import { sortFunc } from '@common/filter/filter-utils';

export class PaymentTableFilterFieldProvider implements FilterFieldProvider {

  private readonly fieldMetaDataCollection = new FieldMetadataCollection();

  constructor(
    private readonly rows: Array<IRow>,
    private readonly columns: Array<ITableColumn>
  ) {
    this.initialiseFields();
  }

  private initialiseFields() {

    const fieldMetaDataBuilder = new FieldMetadataCollectionBuilder(this.fieldMetaDataCollection);

    const optionBuilder = new ArrayToFilterListItemBuilder(this.rows);

    optionBuilder.forProperty('SystemAccountRef', 'SystemAccountRef', (x: IRow) => x.SystemAccountRef);
    optionBuilder.forProperty('SystemAccountName', 'SystemAccountName', (x: IRow) => x.SystemAccountName);
    optionBuilder.forProperty('SystemFamiliarName', 'SystemFamiliarName', (x: IRow) => x.SystemPropertyRef);
    optionBuilder.add('SystemPaidDate', (x: any) => asDate(x.SystemPaidDate), mapDate('SystemPaidDate'));
    optionBuilder.forProperty('SystemType', 'SystemType', (x: IRow) => x.SystemType);
    optionBuilder.forProperty('SystemReference', 'SystemReference', (x: IRow) => x.SystemReference);
    optionBuilder.forProperty('SystemAmount', 'SystemAmount', (x: IRow) => x.SystemAmount);
    optionBuilder.forProperty('SystemCurrency', 'SystemCurrency', (x: IRow) => x.SystemCurrency);

    const options = optionBuilder.build();

    fieldMetaDataBuilder.add('Account Ref', 'SystemAccountRef', 'string', FilterOperators.StringDefaults, options.get('SystemAccountRef'));
    fieldMetaDataBuilder.add('Account Name', 'SystemAccountName', 'string', FilterOperators.StringDefaults, options.get('SystemAccountName'));
    fieldMetaDataBuilder.add('Familiar Name', 'SystemFamiliarName', 'string', FilterOperators.StringDefaults, options.get('SystemFamiliarName'));
    fieldMetaDataBuilder.add('Paid Date', 'SystemPaidDate', 'date', FilterOperators.DateDefaults, options.get('SystemPaidDate'));
    fieldMetaDataBuilder.add('Type', 'SystemType', 'category', FilterOperators.CategoryDefaults, options.get('SystemType'));
    fieldMetaDataBuilder.add('Reference', 'SystemReference', 'number', FilterOperators.Scalar, options.get('SystemReference'));
    fieldMetaDataBuilder.add('Amount', 'SystemAmount', 'number', FilterOperators.Scalar, options.get('SystemAmount'));
    fieldMetaDataBuilder.add('Currency', 'SystemCurrency', 'category', FilterOperators.CategoryDefaults, options.get('SystemCurrency'));

  }

  getFilterFields(): Array<Field> {
    const nonSystemColumns = this.columns.filter(x => !x.Name.startsWith('System'));
    const nonSystemColumnHeaders = nonSystemColumns.map(x => x.Header);
    const fields = this.fieldMetaDataCollection.getFilterFields().map(x => {
      if (nonSystemColumnHeaders.indexOf(x.name) > -1) {
        x['styleClass'] = 'selected-column';
      }
      return x;
    });
    return fields.sort((a, b) => sortFunc(a, b, nonSystemColumnHeaders));
  }

  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

}
